import { collection, CollectionReference, orderBy, Timestamp, where } from "firebase/firestore";

import { useFirestorePagination } from "hooks/useFirestorePagination";
import { firestore } from "libs/firebase";

type HandyStatusType = {
  deviceId: string;
  uid: string;
  shopId: string;
  shopClientId: string;
  name: string;
  version: string;
  nativeAppVersion: string;
  modelName: string;
  osName: string;
  osVersion: string;
  updatedAt: Timestamp;
};

export const useHandyStatusQuery = ({
  variables,
  skip,
}: {
  variables?: {
    shopId: string;
  };
  skip?: boolean;
}) =>
  useFirestorePagination<HandyStatusType>(
    () => ({
      skip: Boolean(skip),
      collection: collection(firestore, "handyStatus") as CollectionReference<HandyStatusType>,
      constraints: variables?.shopId
        ? [where("shopId", "==", variables.shopId), orderBy("updatedAt", "desc")]
        : null,
      getKey: ({ uid, deviceId }: HandyStatusType) => `${uid}-${deviceId}`,
    }),
    [skip, variables?.shopId],
  );
